import { Injectable } from '@angular/core';
import { Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { ApiService } from '../api.service';
import { AuthService } from '../auth.service';

export interface IDocument {
    'id': number;
    'name': string;
    'mime-type': string;
    'content-url': string;
}

export interface IMedia {
    'id': number;
    'name': string;
    'mime-type': string;
}

export interface IApp {
    'id': number;
    'name': string;
    'link': string;
    'categoryId': number;
    'version': string;
    'state': string;
    'requiredDataPackages': number[];
    'permissionGroupIds': number[];
    'description': string;
    'features': string[];
    'documents': IDocument[];
    'media': IMedia[];
    'icon': {
        'mime-type': string;
        'html': string;
    };
    'iconName': string;
    'parentId': number;
    'applicationFeatures': IAppFeature[];
}

export interface IAppFeature {
  'id': string;
  'appId': number;
  'name': string;
  'description': string;
  'link': string;
  'state': string;
  'permissionGroupIds': number[];
  'applicationFeatures': IAppFeature[];
}

@Injectable()
export class AppService {

    private options: any;

    constructor(
        private apiService: ApiService,
        private authService: AuthService
    ) {
        const headers = new Headers({ 'Content-Type': 'application/json' });
        this.options = new RequestOptions({ headers: headers });
        this.apiService.init();
    }

    getApps(fields?: string, filter?: string, sort?: string, page?: string): Observable<IApp[]> {
        return this.apiService.client.apps.GET(fields, filter, sort, page, this.options)
        .map((res) => {
            return this.apiService.handleResponse(res).results;
        });
    }

    getApp(id, fields?: string): Observable<IApp> {
        return this.apiService.client.apps.id(id).GET(fields, this.options)
        .map((res) => {
            return this.apiService.handleResponse(res);
        });
    }

    getNotInstalledApps(): Observable<IApp[]> {
        return this.apiService.client.apps.GET(null, 'state neq "unavailable"', null, null, this.options)
            .map((res) => {
                const apps =  this.apiService.handleResponse(res).results;
                return apps.filter(x => x.permissionGroupIds.filter(pg => this.authService.user.permissionGroupIds.indexOf(pg) !== -1).length > 0)
                    .filter(app => !~this.authService.user.pinnedAppIds.indexOf(app.id));
            });
    }

    getInstalledApps(): Observable<IApp[]> {
        return this.apiService.client.apps.GET(null, 'state neq "unavailable"', null, null, this.options)
            .map((res) => {
                const pinnedApps: IApp[] = [];
                const apps = this.apiService.handleResponse(res).results;
                const accessibleApps = apps.filter(x => x.permissionGroupIds.filter(pg => this.authService.user.permissionGroupIds.indexOf(pg) !== -1).length > 0);
                this.authService.user.pinnedAppIds.filter(x => accessibleApps.find(r => r.id === x)).forEach(pinnedAppId => {
                    pinnedApps.push(accessibleApps.find(r => r.id === pinnedAppId));
                });
                return pinnedApps;
            });
    }
    getAccessibleAppPermissionGroupIdsByPath(path: string): Observable<IApp> {
        return this.apiService.client.apps.GET('permissionGroupIds', `link eq "${path}" and state neq "unavailable"`, null, null, this.options)
            .map((res) => {
                if (this.apiService.handleResponse(res).results.length > 1) {
                    throw new Error('Multiple apps under the same path!');
                }
                return this.apiService.handleResponse(res).results[0];
            });
    }
    getAvailableApps(): Observable<IApp[]> {
      return this.apiService.client.apps.available.GET().map((res) => {
        return this.apiService.handleResponse(res);
      });
    }
}



// WEBPACK FOOTER //
// ./src/app/core/api/app.service.ts